export const projectSelectors = {
	isFetching: (state) => state.project.isFetching,
	isRefresh: (state) => state.project.isRefresh,
	error: (state) => state.project.error,
	content: (state) => state.project.content,
	project: (state) => state.project.content.project,
};
